export const LOGIN_FORM = 'LOGIN_FORM'
export const NEW_PASSWORD_FORM = 'NEW_PASSWORD_FORM'
export const RECLAMO_FORM = 'RECLAMO_FORM'
export const CONSULTA_FORM = 'CONSULTA_FORM'
export const FORM_SOLICITUD_ACCESO = 'FORM_SOLICITUD_ACCESO'
export const FORM_INGRESO_MINIMO = 'FORM_INGRESO_MINIMO'
export const FORM_CONSULTA_CUPO = 'FORM_CONSULTA_CUPO'
export const FORM_INGRESO_COMPLETO = 'FORM_INGRESO_COMPLETO'
export const FORM_REIMPRESION_COMPROBANTE = 'FORM_REIMPRESION_COMPROBANTE'
export const FORM_CONTROL_TURNO = 'FORM_CONTROL_TURNO'
export const FORM_SIN_CUPO = 'FORM_SIN_CUPO'
export const FORM_CPA_EN_PLAYA = 'FORM_CPA_EN_PLAYA'
export const FORM_CPA_ABANDONADA = 'FORM_CPA_ABANDONADA'
export const FORM_ABANDONO = 'FORM_ABANDONO'
export const FORM_DESABANDONO = 'FORM_DESABANDONO'
export const FORM_RECHAZO = 'FORM_RECHAZO'
export const FORM_RECHAZO_EN_PLAYA = 'FORM_RECHAZO_EN_PLAYA'
export const FORM_PROCESO_CALADO = 'FORM_PROCESO_CALADO'
export const FORM_ANULACION_INGRESO = 'FORM_ANULACION_INGRESO'
export const FORM_CUADRO_DE_MANDO = 'FORM_CUADRO_DE_MANDO'
export const FORM_PBI = 'FORM_PBI'
export const FORM_CUADRO_DE_MANDO_EXPORTADOR_CEREAL = 'FORM_CUADRO_DE_MANDO_EXPORTADOR_CEREAL'
export const FORM_CUADRO_DE_MANDO_INGRESO_COMPLETO = 'FORM_CUADRO_DE_MANDO_INGRESO_COMPLETO'
export const FORM_EXISTENCIA_DIARIA = 'FORM_EXISTENCIA_DIARIA'
export const FORM_PENDIENTE_AUTORIZ = 'FORM_PENDIENTE_AUTORIZ'
export const DISPLAY_DIRECTO = 'DISPLAY_DIRECTO'
export const FORM_CAMIONES_CALADOS = 'FORM_CAMIONES_CALADOS'
export const FORM_CALLE_DE_CALADO = 'FORM_CALLE_DE_CALADO'
export const FORM_CAMIONES_PENALIZADOS = 'FORM_CAMIONES_PENALIZADOS'
export const FORM_CUADRO_DE_MANDO_CALADO = 'FORM_CUADRO_DE_MANDO_CALADO'
export const FORM_BUSQUEDACPA = 'FORM_BUSQUEDACPA'
export const FORM_DISPONIBILIDAD_CUPO = 'FORM_DISPONIBILIDAD_CUPO'
export const FORM_EGRESO_CALADO = 'FORM_EGRESO_CALADO'
export const FORM_ANULACION_EGRESO = 'FORM_ANULACION_EGRESO'
export const FORM_PESO_BRUTO = 'FORM_PESO_BRUTO'
export const FORM_PESO_DESTARE = 'FORM_PESO_DESTARE'
export const FORM_PESO_MANUAL = 'FORM_PESO_MANUAL'
export const FORM_PESO_CON_REMITO = 'FORM_PESO_CON_REMITO'
export const FORM_CUADRO_DE_MANDO_MOVIMIENTO = 'FORM_CUADRO_DE_MANDO_MOVIMIENTO'
export const FORM_MOVIMIENTO_DE_SILO = 'FORM_MOVIMIENTO_DE_SILO'
export const FORM_REPESO_BRUTO = 'FORM_PESO_BRUTO'
export const FORM_CUPO = 'FORM_CUPO'
export const FORM_CUPO_MULTIPLE = 'FORM_CUPO_MULTIPLE'
export const FORM_CONTACTO = 'FORM_CONTACTO'
export const FORM_EDICION_CONTACTO = 'FORM_EDICION_CONTACTO'
export const FORM_NOMINACION_CUPO = 'FORM_NOMINACION_CUPO'
export const FORM_CODIGO_CUPO = 'FORM_CODIGO_CUPO'
export const FORM_FUERA_DE_CIRCUITO_BRUTO = 'FORM_FUERA_DE_CIRCUITO_BRUTO'
export const FORM_MOVIMIENTOS_SILOS = 'FORM_MOVIMIENTOS_SILOS'
export const FORM_FUMIGADO_SILOS = 'FORM_FUMIGADO_SILOS'
export const FORM_CUBICAJE_SILOS = 'FORM_CUBICAJE_SILOS'
export const FORM_INICIO_LLENADO_SILOS = 'FORM_INICIO_LLENADO_SILOS'
export const FORM_MODIFICACION_LLENADO_SILOS = 'FORM_MODIFICACION_LLENADO_SILOS'
export const FORM_MODIFICACION_FUMIGADO_SILOS = 'FORM_MODIFICACION_FUMIGADO_SILOS'
export const FORM_MODIFICACION_CUBICAJE_SILOS = 'FORM_MODIFICACION_CUBICAJE_SILOS'
export const FORM_FIN_LLENADO_SILOS = 'FORM_FIN_LLENADO_SILOS'
export const FORM_LIQUI_MERCADERIA_FUMIGADA = 'FORM_LIQUI_MERCADERIA_FUMIGADA'
export const FORM_LIQUI_MERCADERIA_SECADA = 'FORM_LIQUI_MERCADERIA_SECADA'
export const FORM_FILTRO_CEREAL_CEREAL_VARIEDAD_Y_ETIQUETA = 'FORM_FILTRO_CEREAL_CEREAL_VARIEDAD_Y_ETIQUETA'
export const FORM_EGRESO = 'FORM_EGRESO'
export const FORM_PEDIDO_EGRESO = 'FORM_PEDIDO_EGRESO'
export const FORM_PEDIDO_EGRESO_CALADO = 'FORM_PEDIDO_EGRESO_CALADO'
export const FORM_ESTADO_CORTE_CEREAL = 'FORM_ESTADO_CORTE_CEREAL'
export const FORM_NOTIFICACIONES_CHOFER = 'FORM_NOTIFICACIONES_CHOFER'
export const FORM_CARTAS_DE_PORTE_VETADAS = 'FORM_CARTAS_DE_PORTE_VETADAS'
export const FORM_LISTADO_REPRESENTANTES = 'FORM_LISTADO_REPRESENTANTES'
export const FORM_LISTADO_DESCARGAS = 'FORM_LISTADO_DESCARGAS'
export const FORM_LISTADO_RECHAZOS = 'FORM_LISTADO_RECHAZOS'
export const FORM_LISTADO_MOVIMIENTOS_MERCADERIA = 'FORM_LISTADO_MOVIMIENTOS_MERCADERIA'
export const FORM_LISTADO_RECHAZOS_ADM = 'FORM_LISTADO_RECHAZOS_ADM'
export const FORM_LISTADO_DESCARGA_ENTREGADORES = 'FORM_LISTADO_DESCARGA_ENTREGADORES'
export const FORM_LISTADO_MUESTRAS_ENVIADAS = 'FORM_LISTADO_MUESTRAS_ENVIADAS'
export const FORM_HUELLA = 'FORM_HUELLA'
export const FORM_CEREAL_A_VOLCADORA = 'FORM_CEREAL_A_VOLCADORA'
export const FORM_TAREA_MOVIMIENTO = 'FORM_TAREA_MOVIMIENTO'
export const FORM_EDICION_BUQUE = 'FORM_EDICION_BUQUE'
export const FORM_EDICION_CARATULA = 'FORM_EDICION_CARATULA'
export const FORM_ADD_CARATULA = 'FORM_ADD_CARATULA'
export const FORM_EDICION_COEM = 'FORM_EDICION_COEM'
export const FORM_COEM_ADD = 'FORM_COEM_ADD'
export const FORM_LISTADO_COEMS = 'FORM_LISTADO_COEMS'
export const FORM_LINE_UP_BUQUES = 'FORM_LINE_UP_BUQUES'
export const FORM_BUQUES = 'FORM_BUQUES'
export const FORM_PLAN_DE_EMBARQUE = 'FORM_PLAN_DE_EMBARQUE'
export const FORM_BODEGAS_BUQUES = 'FORM_BODEGAS_BUQUES'
export const FORM_CONFIGURACION_SISTEMA = 'FORM_CONFIGURACION_SISTEMA'
export const FORM_PRODUCTIVIDAD_VOLCADORAS = 'FORM_PRODUCTIVIDAD_VOLCADORAS'
export const FORM_EDICION_CANTIDAD_CUPO = 'FORM_EDICION_CANTIDAD_CUPO'
export const FORM_MODIFICAR_CPA = 'FORM_MODIFICAR_CPA'
export const FORM_ALMACENAJE_MERCADERIA = 'FORM_ALMACENAJE_MERCADERIA'
export const FORM_ALMACENAJE_ESPECIAL = 'FORM_ALMACENAJE_ESPECIAL'
export const FORM_TRANSFERENCIAS_EXPORTADOR = 'FORM_TRANSFERENCIAS_EXPORTADOR'
export const FORM_ESTIMACION_STOCK = 'FORM_ESTIMACION_STOCK'
export const FORM_PERFIL = 'FORM_PERFIL'
export const FORM_RESUMEN_DESCARGA = 'FORM_RESUMEN_DESCARGA'
export const FORM_RESUMEN_CARGA = 'FORM_RESUMEN_CARGA'
export const FORM_MERCADERIA_SIN_ANALISIS = 'FORM_MERCADERIA_SIN_ANALISIS'
export const FORM_MERCADERIA_EMBARCADA = 'FORM_MERCADERIA_EMBARCADA'
export const FORM_CEREALES = 'FORM_CEREALES'
export const FORM_VENTA_A_EXPORTADOR = 'FORM_VENTA_A_EXPORTADOR'
export const FORM_CONTROL_DE_GRADO = 'FORM_CONTROL_DE_GRADO'
export const FORM_CONTROL_DE_REBAJAS = 'FORM_CONTROL_DE_REBAJAS'
export const FORM_ARCHIVO_ANALISIS = 'FORM_ARCHIVO_ANALISIS'
export const FORM_CAMBIO_CEREAL_EXPORTADOR = 'FORM_CAMBIO_CEREAL_EXPORTADOR'
